import React from "react";
import * as Styled from "./styles";
function InitialView({ content = [], handleSelectKeyword = () => {} }) {
  return (
    <Styled.Container width="100%">
      {content?.length &&
        content?.map((c) => (
          <Styled.TileContainer onClick={() => handleSelectKeyword(c?.title)}>
            <Styled.TitleContainer key={c?.id}>
              <Styled.TextSpan>{c?.title} </Styled.TextSpan>
            </Styled.TitleContainer>
          </Styled.TileContainer>
        ))}
    </Styled.Container>
  );
}

export default InitialView;
